import { Outlet } from "@tanstack/react-router";
import Loading from "../components/shared/Loading";

export function RouterOutlet() {
  return <Outlet />;
}

export function RouterPending() {
  return (
    <div role="status" aria-label="Loading">
      <Loading loading={true} />
    </div>
  );
}

export function RouterError({ error }: { error: unknown }) {
  return (
    <div role="alert">
      {error instanceof Error ? error.message : String(error)}
    </div>
  );
}
